module.exports = __webpack_public_path__ + "static/img/loginlogo.473ea27d.png";